import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthorizationData } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IAuthorizeLdapRequest {
  operation: string;
  nextURI: string;
  password: string;
  context: { [key: string]: string };
}

export interface IAuthorizeLdapOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (body: IAuthorizeLdapRequest, opts: IAuthorizeLdapOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["ldap", "authorize"]);
  const { operation, password, nextURI, context } = body;

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(uri)) : false,
  });

  const localRequestOpts: RequestInit = {
    body: JSON.stringify({ operation, password, nextURI, context }),
    credentials: "include",
    headers,
    method: "POST",
    mode: "cors",
  };

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function authorizeLdap(
  body: IAuthorizeLdapRequest,
  opts: IAuthorizeLdapOpts,
): Promise<JsonQuery<IResultstash<IAuthorizationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthorizationData>>(createRequest(body, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default authorizeLdap;
